import { isAnyBlank } from '../utils/utils';
import { useEffect } from 'react';

/**
 * 自定义 Hook:设置页面标题
 * @param {string} title - 页面标题
 * @param {string} defaultTitle - 默认标题(可选,默认为'上检检测')
 */
const usePageTitle = (title, defaultTitle = '上检检测') => {
  useEffect(() => {
    // 设置页面标题
    const previousTitle = document.title;
    document.title = !isAnyBlank(title)
      ? `${title} - ${defaultTitle}`
      : defaultTitle;

    // 清理函数:组件卸载时恢复之前的标题
    return () => {
      document.title = previousTitle;
    };
  }, [title, defaultTitle]);
};

export default usePageTitle;
